module.exports = __webpack_public_path__ + "static/img/brief-ction1.66393d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/brief-ction1.jpg
// module id = 2tJ0
// module chunks = 1